"use strict";

class NavTabContainer extends HTMLElement {
    constructor(){
        super();
        this.buildSelectors();
        this.menuHandle = this.dataset.menuHandle;
        this.handleTabChange = this.handleTabChange.bind(this);
        this.handleTabKeyboardEvent = this.handleTabKeyboardEvent.bind(this);
    }

    connectedCallback(){
        if(this.tabBtns.length > 1){
            this.tabBtns.forEach(btn => {
                btn.addEventListener('click', this.handleTabChange);
                btn.addEventListener('keyup', this.handleTabKeyboardEvent);
            });

            this.initFeaturedSlider();
        }
        
        if(this.menuHandle !== "shop-by-brand") return;
        
        this.handleBrandTabChange = this.handleBrandTabChange.bind(this);
        this.initBrandTab();
    }
    
    disconnectedCallback(){
        if(this.tabBtns.length > 1) {
            this.tabBtns.forEach(btn => {
                btn.removeEventListener('click', this.handleTabChange);
                btn.removeEventListener('keyup', this.handleTabKeyboardEvent);
            });
        }

        if(this.menuHandle !== "shop-by-brand") return;

        this.accordBtns.forEach(tab => {
            tab.removeEventListener('click', this.handleBrandTabChange);
        });
    }
    
    buildSelectors(){
        this.tabBtns = this.querySelectorAll('[data-tab-panel-btn]');
        this.tabPanels = this.querySelectorAll('[data-tab-panel-content]');
        this.featuredSliderContainer = this.querySelector('.featured-brands-container');
    }

    handleTabChange(evt){
        const target = evt.currentTarget;
        const tabPanelId = target.dataset.tabId;
        if(!tabPanelId) return;

        this.tabBtns.forEach(tab => {
            let tabID = tab.getAttribute('data-tab-id');
            if(tabID == tabPanelId){
              tab.classList.add('active');
              tab.setAttribute('aria-selected', true);
              tab.removeAttribute('tabindex');
              tab.focus();
            }else{
              tab.classList.remove('active');
              tab.setAttribute('aria-selected', false);
              tab.setAttribute('tabindex', -1);
            }
        });
    
        this.tabPanels.forEach(panel => {
            let panelID = panel.getAttribute('data-panel-id');
            if(panelID == tabPanelId){
                panel.classList.add('active');
                panel.setAttribute('tabindex', 0);
                panel.setAttribute('aria-hidden','false')
            }else{
                panel.classList.remove('active');
                panel.removeAttribute('tabindex');
                panel.setAttribute('aria-hidden','true')
            }
        });

        if(this.featuredSliderContainer && this.featuredSliderContainer.slick){
            this.featuredSliderContainer.slick.refresh();
        }
    }

    handleTabKeyboardEvent(evt){
        if(!['ArrowLeft', 'ArrowRight'].includes(evt.key)) return;
                    
        evt.preventDefault();
        const target = evt.target;
        const prevSiblings = target.previousElementSibling;
        const nextSiblings = target.nextElementSibling;
        
        if(evt.key === "ArrowLeft" && prevSiblings){
            prevSiblings.click();
            // this.handleTabChange({currentTarget: prevSiblings});
        }

        if(evt.key === "ArrowRight" && nextSiblings) {
            nextSiblings.click();
            // this.handleTabChange({currentTarget: nextSiblings});
        }
    }

    addBrandsItems(letter, accordionBody){
        if(!accordionBody) return;

        let listElem = accordionBody.querySelector('ul');
        if(listElem) return;

        listElem = document.createElement('ul');
        listElem.setAttribute('data-accordion-brands-list', '');
        _theme.vendors.forEach((brand) => {
            const first_letter = brand.substr(0, 1).toLowerCase().trim();
            if(letter === first_letter){
                const listItem = document.createElement('li');
                const listItemLink = document.createElement('a');
                listItemLink.setAttribute('aria-label', brand);
                listItemLink.href = `/collections/${_theme.Helpers.handleize(brand)}`;
                listItemLink.textContent = brand;
                listItem.appendChild(listItemLink);
                listElem.appendChild(listItem);
            }
        });

        if(listElem.childElementCount > 0) accordionBody.appendChild(listElem);
    }

    handleBrandTabChange(evt){
        const accordionHeader = evt.currentTarget;
        const letter = accordionHeader.dataset.letter;
        const accordionBody = accordionHeader.parentElement.querySelector('[data-accordion-body]');

        this.addBrandsItems(letter, accordionBody);

        if (accordionBody.style.maxHeight) {
            accordionBody.style.maxHeight = null;
            accordionBody.setAttribute('aria-hidden','true')
            accordionHeader.classList.remove('triggered-btn')
            accordionHeader.setAttribute('aria-expanded','false')
        } else {
            accordionBody.setAttribute('aria-hidden','false')
            accordionBody.style.maxHeight = accordionBody.scrollHeight + "px";
            accordionHeader.classList.add('triggered-btn')
            accordionHeader.setAttribute('aria-expanded','true')
        }
    }

    initBrandTab(){
        this.accordBtns = this.querySelectorAll('[data-accordion-btn]');
        this.accordBodyElems = this.querySelectorAll('[data-accordion-body]');

        this.accordBtns.forEach(tab => {
            tab.addEventListener('click', this.handleBrandTabChange);
        });
    }

    initFeaturedSlider(){
        if(!this.featuredSliderContainer || !_theme.initSlickSlider) return;

        _theme.initSlickSlider(
            $(this.featuredSliderContainer),
            {
                infinite : false,
                speed: 300,
                slidesToShow: 2.5,
                slidesToScroll: 1,
                prevArrow:'<button tabindex="-1" type="button" aria-label="previous" class="slick-arrow slick-prev"><img width="13" height="13" loading="lazy" sizes="24px" src="https://cdn.shopify.com/s/files/1/0269/7763/2389/files/new-slider-arrow.svg?v=163394481" alt="Previous Arrow" style="cursor:pointer;"></button>',
                nextArrow:'<button tabindex="0" type="button" aria-label="next" class="slick-arrow slick-next"><img width="13" height="13" loading="lazy" sizes="24px" src="https://cdn.shopify.com/s/files/1/0269/7763/2389/files/new-slider-arrow.svg?v=163394481" alt="Next Arrow" style="cursor:pointer;"></button>'
            }
        )
    }

}

customElements.define('nav-tab-container', NavTabContainer);